import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-itallic-icon',
  templateUrl: './text-itallic.component.html'
})
export class TextItallicComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
